import { render, staticRenderFns } from "./CommoditySiteProfile.vue?vue&type=template&id=22a957b1"
import script from "./CommoditySiteProfile.vue?vue&type=script&lang=js"
export * from "./CommoditySiteProfile.vue?vue&type=script&lang=js"
import style0 from "./CommoditySiteProfile.vue?vue&type=style&index=0&id=22a957b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports